module.exports = __webpack_public_path__ + "static/media/icad.810cdf84.svg";